export class ReportSettings {
  public defaultColumns: string[];
  public optionalColumns: any[];
}
